// extracted by mini-css-extract-plugin
export default {"mainContainer":"SetTimeHolidayPage_mainContainer__-UFCP","innerTimeContainer":"SetTimeHolidayPage_innerTimeContainer__Q9OkU"};